import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useOpenDialog } from '#src/hooks/navigation/useOpenDialog.ts';
import { useQueryString } from '#src/hooks/useQueryString.ts';

export const usePromptVerifyPhone = () => {
  const { currentUser } = useCurrentUserContext();

  const action = useQueryString('action');
  const dialogOpen = useQueryString(DialogKey.verifyPhone);
  const openDialog = useOpenDialog();

  if (
    action !== 'verifyPhone' ||
    !currentUser ||
    currentUser.phoneNumberVerified ||
    dialogOpen
  ) {
    return;
  }

  openDialog(DialogKey.verifyPhone, '1', { replace: true });
};
